<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">
        <v-text-field v-if="show" label="Numar autorizatie" placeholder="Completati doar daca se doreste suprascrierea"
          v-model="document.number">
        </v-text-field>

        <h2>Parametrii aparatului</h2>

        <v-text-field label="Randament" v-model="document.yield" :rules="requiredRule" required>
        </v-text-field>

        <v-btn color="primary" @click="showRegistration = !showRegistration">Completeaza inregistrare</v-btn>

        <v-text-field v-if="showRegistration" label="Inregistrat la" v-model="document.registerdAt">
        </v-text-field>

        <v-text-field v-if="showRegistration" label="Nr. inregistrare" v-model="document.registerNumber">
        </v-text-field>

        <v-text-field label="Puterea maxima/minima (kw):" v-model="document.maxminPower">
        </v-text-field>

        <v-switch label="Aparat nou" v-model="document.isNewDevice" class="mx-2"> </v-switch>

        <v-switch label="Aparat vechi" v-model="document.isOldDevice" class="mx-2"> </v-switch>

        <v-switch label="Verificare tehnica periodica" v-model="document.needsVTP" class="mx-2">
        </v-switch>

        <v-switch label="Repunere in functiune dupa reparare" v-model="document.needsRestart" class="mx-2">
        </v-switch>

        <v-text-field label="Observatii" v-model="document.observations"> </v-text-field>

        <h2>V.1. VERIFICARI LA RECE</h2>

        <v-text-field label="Tensiune Electrica" v-model="document.electricVoltage"> </v-text-field>

        <h2>V.3. VERIFICARI LA CALD</h2>

        <p>Tip tiraj</p>
        <v-radio-group v-model="document.circulationType">
          <v-radio label="Natural" value="natural"></v-radio>
          <v-radio label="Fortat" value="fortat"></v-radio>
        </v-radio-group>

        <v-text-field label="Tiraj" v-model="document.circulation"> </v-text-field>

        <v-text-field label="Presiunea gazului la intrarea pe rampa de gaz" v-model="document.entryGasRamp">
        </v-text-field>

        <v-btn color="primary" @click="showEntryGasBurner = !showEntryGasBurner">
          Completeaza presiunea in arzator
        </v-btn>
        <div v-if="showEntryGasBurner">
          <v-text-field label="Presiunea gazului la intrarea in arzator" v-model="document.entryGasBurner">
          </v-text-field>

          <v-radio-group v-model="document.entryGasBurnerOption">
            <v-radio label="DA" value="yes"></v-radio>
            <v-radio label="N/A" value="na"></v-radio>
          </v-radio-group>
        </div>

        <v-text-field label="Presiunea gazului la intrarea in focar" v-model="document.entryGasFocus">
        </v-text-field>

        <h2>Analiza gazelor arse</h2>

        <v-row align="center">
          <v-col>
            <v-select v-model="document.analyzer" :items="$store.state.analyzers.analyzers" prepend-icon="engineering"
              item-text="name" item-value="id" label="Analizor" :rules="requiredRule" required return-object></v-select>
          </v-col>
          <v-col cols="auto">
            <v-btn v-if="isTestoAnalyzer" color="primary" @click="showQrScanner = true">
              Scaneaza cod QR
            </v-btn>
          </v-col>
        </v-row>
        <QrScannerDialog v-if="showQrScanner" @detected="onQrDetected" @error="onQrError"
          @close="showQrScanner = false" />

        <v-text-field label="O2 masurat [%]" v-model="document.measuredO2"> </v-text-field>

        <v-text-field label="CO masurat [ppm]" v-model="document.measuredCO"> </v-text-field>

        <v-text-field label="Temperatura gazelor arse" v-model="document.temperatureBurnedGas">
        </v-text-field>

        <v-text-field label="CO2" v-model="document.measuredCO2"> </v-text-field>

        <v-text-field label="NO2[x] masurat" v-model="document.measuredNO"> </v-text-field>

        <v-btn color="primary" @click="showMeasuredSO = !showMeasuredSO"> Completeaza SO2 </v-btn>
        <v-text-field v-if="showMeasuredSO" label="SO2[x] masurat" v-model="document.measuredSO">
        </v-text-field>

        <v-text-field label="Exces aer" v-model="document.excessAir"> </v-text-field>

        <v-text-field label="Eficienta ardere [%]" v-model="document.burnEfficiency">
        </v-text-field>

        <h2>Rezultate analiza</h2>

        <v-file-input label="Incarca rezulate analiza" prepend-icon="mdi-camera" @change="convertToBase64">
        </v-file-input>

        <v-btn color="red" v-if="document.analyserPhoto" @click="document.analyserPhoto = ''">Sterge rezultate
          analiza</v-btn>

        <v-img v-if="document.analyserPhoto" :src="document.analyserPhoto" max-height="300" contain />

        <h2>VI. CONCLUZII</h2>

        <v-menu ref="menuDate" v-model="menuDate" :close-on-content-click="false"
          :return-value.sync="document.checkExpiryDate" transition="scale-transition" offset-y min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="document.checkExpiryDate" label="Data expirare" prepend-icon="event" readonly
              v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="document.checkExpiryDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuDate = false">Cancel</v-btn>
            <v-btn text color="primary" @click="$refs.menuDate.save(document.checkExpiryDate)">OK</v-btn>
          </v-date-picker>
        </v-menu>

        <v-radio-group v-model="document.livretStatus">
          <v-radio label="ADMIS" value="accepted"></v-radio>
          <v-radio label="RESPINS" value="rejected"></v-radio>
        </v-radio-group>

        <SignaturePad ref="signatureRef" />

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
          <v-btn @click="preview" color="primary">Previzualizare</v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import SignaturePad from '@/components/documents/SignaturePad.vue';
import QrScannerDialog from '@/components/documents/QrScannerDialog.vue';
import { busEvent } from '../../main';
import { mapActions } from 'vuex';
import { hasAccess, PERMISSION_LEVEL_ADMIN } from '../../utils/permissions';
import { parseTestoQrPayload } from '../../utils/testoQrParser';

export default {
  components: {
    SignaturePad,
    QrScannerDialog,
  },
  data() {
    return {
      show: hasAccess(PERMISSION_LEVEL_ADMIN),
      valid: true,
      showRegistration: false,
      showEntryGasBurner: false,
      showMeasuredSO: false,
      showQrScanner: false,
      menuDate: false,
      document: {
        number: '',
        type: 'livret',
        yield: '',
        registerdAt: '',
        registerNumber: '',
        isNewDevice: false,
        isOldDevice: false,
        needsVTP: false,
        needsRestart: false,
        observations: '',
        circulation: '',
        entryGasRamp: '',
        entryGasBurner: '',
        entryGasFocus: '',
        temperatureBurnedGas: '',
        measuredCO: '',
        measuredO2: '',
        measuredNO: '',
        measuredSO: '',
        measuredCO2: '',
        excessAir: '',
        burnEfficiency: '',
        electricVoltage: '',
        circulationType: 'fortat',
        livretStatus: 'accepted',
        maxminPower: '',
        entryGasBurnerOption: 'na',
        analyserPhoto: '',
        signature: null,
        checkExpiryDate: this.addYearsToNow(2),
      },
      requiredRule: [(v) => !!v || 'Campul trebuie completat.'],
    };
  },

  async created() {
    this.getAnalyzers();

    // check if we're on edit screen
    if (this.$route.name === 'Editare livret') {
      const document = await this.$store.dispatch('documents/getDocument', {
        clientId: this.$route.params.clientId,
        documentId: this.$route.params.id,
      });

      this.document = {
        ...document.props,
        number: document.number,
        documentId: document.id,
      };
      this.$refs.signatureRef.setSignature(document.props.signature);
    }
  },
  computed: {
    isTestoAnalyzer() {
      return (
        !!this.document.analyzer &&
        typeof this.document.analyzer.name === 'string' &&
        this.document.analyzer.name.toLowerCase().includes('testo')
      );
    },
  },
  methods: {
    ...mapActions('analyzers', ['getAnalyzers']),

    onQrDetected({ binaryData }) {
      this.showQrScanner = false;

      try {
        const scannedValues = parseTestoQrPayload(binaryData);

        if (Object.keys(scannedValues).length === 0) {
          busEvent.$emit('errorPopupCreated', 'Codul QR scanat nu contine valori recunoscute.');
          return;
        }

        Object.entries(scannedValues).forEach(([field, value]) => {
          this.document[field] = value;
        });

        if (scannedValues.measuredSO !== undefined) {
          this.showMeasuredSO = true;
        }

        busEvent.$emit('succesPopupCreated', 'Datele au fost completate din codul QR');
      } catch (e) {
        busEvent.$emit('errorPopupCreated', 'Codul QR scanat nu este un cod QR Testo valid.');
      }
    },

    onQrError(message) {
      this.showQrScanner = false;
      busEvent.$emit('errorPopupCreated', message);
    },

    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.document.signature = this.$refs.signatureRef.getSignature();

        if (this.$route.name === 'Editare livret') {
          this.$store
            .dispatch('documents/update', {
              clientId: this.$route.params.clientId,
              body: this.document,
            })
            .then(() => {
              busEvent.$emit('succesPopupCreated', 'Livretul a fost editat');
              this.$router.back();
            });
        } else {
          this.$store
            .dispatch('documents/create', {
              clientId: this.$route.params.clientId,
              body: this.document,
            })
            .then(() => {
              busEvent.$emit('succesPopupCreated', 'Livretul a fost creat');
              this.$router.back();
            });
        }
      }
    },
    async preview() {
      this.document.signature = this.$refs.signatureRef.getSignature();

      if (this.$refs.form.validate() && this.valid) {
        const response = await this.$store.dispatch('documents/preview', {
          clientId: this.$route.params.clientId,
          body: this.document,
        });

        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        const fileName = response.headers['content-disposition'].match("filename='(.*)'");
        fileLink.setAttribute('download', fileName[1]);
        document.body.appendChild(fileLink);
        fileLink.click();
        fileLink.remove();
      }
    },

    convertToBase64(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        this.document.analyserPhoto = e.target.result.toString();
      };
    },

    addYearsToNow(years) {
      const currentDate = new Date();
      currentDate.setFullYear(currentDate.getFullYear() + years);
      return currentDate.toISOString().substr(0, 10)
    }
  },
};
</script>

<style></style>
